import type { ReactNode } from "react";

/** One search condition inside the search bar. `excluded` draws the struck-through "must not have" form. */
export function Token({
  namespace,
  excluded = false,
  removeLabel,
  onRemove,
  children,
}: {
  namespace?: string;
  excluded?: boolean;
  removeLabel: string;
  onRemove: () => void;
  children: ReactNode;
}) {
  return (
    <span className={excluded ? "tk tk-x" : "tk"} data-testid="token">
      <span className="tk-text">
        {namespace && <i>{namespace}</i>}
        {children}
      </span>
      <button type="button" aria-label={removeLabel} onClick={onRemove}>
        ×
      </button>
    </span>
  );
}
